import api from "@/api";
import validate from "../../../shared/validation/detailAlbum.vaildation";


class DetailAlbumState {
    constructor() {
        this.album = {
            id: 0,
            name: "",
            nameEn: "",
            albumType: "",
            desc: "",
            registerType: "",
            hasInitBalanceAmount: false,
            initBalanceAmount: 0,
            bespokRate: 0,
            status: "",
        };

        this.error = {};
        this.fieldChangedFlags = {};
    }
}


export default {
    namespaced: true,
    state: new DetailAlbumState(),
    getters: {
        album: (state) => state.album,
        error: (state) => state.error,
    },
    mutations: {
        setAlbum(state, album) {
            state.album = album;
        },
        async changeAlbumField(state, [key, value]) {
            state.album[key] = value;
            state.fieldChangedFlags[key] = true;

            const {error} = await validate(state.album, { fieldChangedFlags: state.fieldChangedFlags, editMode: true});
            state.error = error;
        },
    },
    actions: {
        createAlbum: async({ state }) => {
            // todo : validation
            const result = await api.album.createAlbum(state.album);
            return result;
        },
        getDetailAlbum: async({ commit }, id) => {
            const album = await api.album.getDetailAlbum(id);
            commit("setAlbum", album);
        }
    }
}